import angular from "angular";

const ERROR_MESSAGE_MAP = {
    DOMAIN_NAME_ALREADY_TAKEN: 'error.functional.domain_name_already_taken',
    UNAUTHORIZED_DOMAIN_NAMES: 'error.functional.unauthorized_domain_name'
};
class PrincipalConfigPortalCtrl {
    /*@ngInject*/
    constructor(
        PrincipalSvc,
        $state,
        AuthSvc,
        logger,
        $uibModal,
        User,
        KissUserSvc,
        UsersFilter,
        EMAIL_REGEXP,
        $stateParams,
        DEMAT_PLATFORMS,
        PLATFORM_PATHS,
        DOMAIN_NAME_REGEX
    ) {
        this.PrincipalSvc = PrincipalSvc;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.logger = logger;
        this.$uibModal = $uibModal;
        this.admin = new User();
        this.KissUserSvc = KissUserSvc;
        this.UsersFilter = UsersFilter;
        this.$stateParams = $stateParams;
        this.DEMAT_PLATFORMS = DEMAT_PLATFORMS;
        this.PLATFORM_PATHS = PLATFORM_PATHS;
        this.DOMAIN_NAME_REGEX = DOMAIN_NAME_REGEX;
    }

    $onInit() {
        this._initializeTemplates();
        this._initializeData();
        this._initializePlatformPaths();

        this.PrincipalSvc.getWorkflowReferences(this.eid).then((result) => {
            this.wkfReferences = result;
        });
    }

    _initializeTemplates() {
        this.headerTemplate = require("./principal-header-info.html");
        this.includes = {
            errorMessages: require("../layouts/error-messages.html"),
        };
    }

    _initializeData() {
        this.resetPrincipal = angular.copy(this.principal);
        this.invoiceRecepted = this.principal.detail.processP2p;
        this.invoiceSent = this.principal.detail.processO2c;
        this.isPortalActivate =
            this.principal.detail.processP2p ||
            this.principal.detail.processO2c;
        this.hasAdmins = false;
        this.invalidDomainsList = "";
        this.invalidDomainsErrorMessage = "";
        if (!this.create) {
            this.initHasAdmins();
        }
        if (
            this.PrincipalSvc.getAdmin() != null &&
            this.PrincipalSvc.getAdmin().email != null
        ) {
            this.admin = this.PrincipalSvc.getAdmin();
        }
        this.eid = this.PrincipalSvc.getPrincipalEid();
        if (!this.eid == null || this.$stateParams.eid != undefined) {
            this.eid = this.$stateParams.eid;
        }
        if (!this.principal.detail.threeWayMatchingRef) {
            this.principal.detail.threeWayMatchingRef = "sywstd";
        }

        if (!this.principal.detail.ssoIdentifier) {
            this.principal.detail.ssoIdentifier = this.principal.detail.appId;
        }
    }

    _initializePlatformPaths() {
        let platformBase = this.principal.detail.plateform.toLowerCase();
        if (!this.principal.detail.pcpSellerPlatformPathFacturX) {
            this.principal.detail.pcpSellerPlatformPathFacturX =
                `${platformBase}/${this.PLATFORM_PATHS.FACTURE_X.GIS_OR_PASREL_DEFAULT_FOLDER}`;
        }

        if (!this.principal.detail.eInvoicingPlatformPath) {
            this.principal.detail.eInvoicingPlatformPath =
                platformBase.trim().toLowerCase() ===
                    this.DEMAT_PLATFORMS.PASREL ?
                        `${platformBase}/${this.PLATFORM_PATHS.E_INVOICING.PASREL_FULL_DEFAULT_PATH}` :
                        `${platformBase}/${this.PLATFORM_PATHS.E_INVOICING.GIS_OR_PASREL_DEFAULT_FOLDER}`;
        }
    }

    /**
     * Permet de vérifier si le DO posséde des administrateurs
     */
    initHasAdmins() {
        if (!this.create) {
            var filter = new this.UsersFilter();
            filter.role = "ADMIN_FO";
            this.PrincipalSvc.searchUsers(
                this.principal.detail.id,
                filter
            ).then((searchResult) => {
                this.hasAdmins = searchResult.users.length > 0;
            });
        }
    }

    prev() {
        this.principal = angular.copy(this.resetPrincipal);
        this.PrincipalSvc.setAdmin(this.admin);
        this.PrincipalSvc.changeCreationStep(2, 1);
        this.$state.go("app.principal.create.detail");
    }

    checkInputsThenNext() {
        this._checkExchangePaths()
            .then(() => this.checkSsoIdentifierExistence());
    }

    onInvalidTag(tag) {
        this.form.ssoDomains.$setValidity('invalidDomains', true);
        if (!tag || !tag.text) return false;

        const domain = tag.text.trim().toLowerCase();

        const isValid = this.DOMAIN_NAME_REGEX.test(domain);
        this.form.ssoDomains.$setValidity('invalidPattern', isValid);
        this.form.ssoDomains.$setDirty();

        if (isValid) {
            tag.text = domain;
        }

        return isValid;
    }

    onTagRemoved() {
        this.form.ssoDomains.$setValidity('invalidDomains', true);
    }
    /**
     * Permet de vérifier si les répertoires d'échange existent ou non
     *
     */
    _checkExchangePaths() {
        return new Promise((resolve, reject) => {
            // If FacturX deposit is not enabled, skip this check
            if (
                !this.principal.detail.facturXDeposit &&
                !this.principal.detail.eInvoiceEntry
            ) {
                return resolve();
            }
            const checkPromises = [];

            if (this.principal.detail.facturXDeposit) {
                const facturXPath =
                    this.principal.detail.pcpSellerPlatformPathFacturX;
                const facturXPromise =
                    this.PrincipalSvc.checkFacturXExchangeDirectoryExistence(
                        facturXPath
                    ).then((data) => {
                        if (!data) {
                            this.form.pcpSellerPlatformPathFacturX.$setValidity(
                                "platformPathFacturxNotExist",
                                false
                            );
                            return Promise.reject("FacturX path invalid");
                        }
                        return true;
                    });
                checkPromises.push(facturXPromise);
            }

            if (this.principal.detail.eInvoiceEntry) {
                const eInvoicePath =
                    this.principal.detail.eInvoicingPlatformPath;
                const eInvoicePromise =
                    this.PrincipalSvc.checkFacturXExchangeDirectoryExistence(
                        eInvoicePath
                    ).then((data) => {
                        if (!data) {
                            this.form.eInvoicingPlatformPath.$setValidity(
                                "platformPathEInvoiceNotExist",
                                false
                            );
                            return Promise.reject("E-Invoice path invalid");
                        }
                        return true;
                    });

                checkPromises.push(eInvoicePromise);
            }

            // Wait for all path checks to complete
            Promise.all(checkPromises)
                .then(() => resolve())
                .catch((error) => reject(error));
        });
    }

    checkSsoIdentifierExistence() {
        if (
            this.principal.detail.ssoIdentifier === this.principal.detail.appId
        ) {
            this.performAdminCheck();
        } else {
            this.PrincipalSvc.checkAppIdExist(
                this.principal.detail.ssoIdentifier
            ).then(
                () => {
                    this.performAdminCheck();
                },
                (error) => {
                    // EID n'existe sur aucun DO
                    if (
                        error.status === 400 &&
                        error.data &&
                        error.data.code === "UNKNOWN_PRINCIPAL_APPID"
                    ) {
                        this.form.ssoIdentifier.$setValidity(
                            "unknownPcpAppId",
                            false
                        );
                    }
                }
            );
        }
    }

    platformPathFacturXChange() {
        if (
            this.form.pcpSellerPlatformPathFacturX.$error
                .platformPathFacturxNotExist
        ) {
            this.form.pcpSellerPlatformPathFacturX.$setValidity(
                "platformPathFacturxNotExist",
                true
            );
        }
        if (
            this.form.eInvoicingPlatformPath.$error.platformPathEInvoiceNotExist
        ) {
            this.form.eInvoicingPlatformPath.$setValidity(
                "platformPathEInvoiceNotExist",
                true
            );
        }
    }

    /**
     * Permet de vérifier si l'utilisateur(admin) existe ou non
     *
     */
    performAdminCheck() {
        if (this.mustCreateAdmin()) {
            this.KissUserSvc.checkContactEmail(this.admin.email).then(
                (user) => {
                    if (user.id === null) {
                        this.redirectToNext();
                    } else {
                        if (user.isNotAdmin() && user.isNotAccountant()) {
                            this.showAdminConfirmationModal(user);
                        } else {
                            this.$uibModal.open({
                                component: "adminCreationErrorModal",
                                size: "md",
                                backdrop: "static",
                                keyboard: false,
                            });
                        }
                    }
                },
                (error) => {
                    this.logger.error(
                        "error.admin_unauthorised_domain_name_mail",
                        error
                    );
                }
            );
        } else {
            this.redirectToNext();
        }
    }

    redirectToNext() {
        if (this.create) {
            this.next();
        } else {
            this.checkAndUpdate();
        }
    }
    /**
     * affiche le modal de confirmation d'ajout du rôle admin a l'utilisateur existant
     * @param {*} user utilisateur auquel on va ajouter le rôle admin
     */
    showAdminConfirmationModal(user) {
        this.KissUserSvc.getUser(user.login).then((userBo) => {
            this.$uibModal
                .open({
                    component: "adminCreationConfirmationModal",
                    size: "md",
                    resolve: {
                        authorization: () => {
                            return userBo.user.legalEntityGroupUsers;
                        },
                    },
                    backdrop: "static",
                    keyboard: false,
                })
                .result.then(
                () => {
                    this.admin = userBo.user;
                    this.redirectToNext();
                },
                function () {}
            );
        });
    }
    next() {
        this.PrincipalSvc.setPrincipal(this.principal);

        if (this.principal.detail.profilBuyer) {
            // sauvegarde de l'admin à créer
            this.PrincipalSvc.setAdmin(this.admin);
            this.PrincipalSvc.changeCreationStep(2, 3);
            this.$state.go("app.principal.create.kiss");
        } else {
            var ctrl = this;
            this.PrincipalSvc.createPrincipal(this.principal).then(
                (principal) => {
                    if (this.mustCreateAdmin()) {
                        this.PrincipalSvc.createPrincipalAdmin(
                            principal.detail.id,
                            this.admin
                        ).then(() =>
                            ctrl.$state.go("do", { tabName: "principal" })
                        );
                    } else {
                        ctrl.$state.go("do", { tabName: "principal" });
                    }
                },
                (error) => ctrl.logger.error("error.create_principal", error)
            );
        }
    }

    cancel() {
        this.principal = angular.copy(this.resetPrincipal);
        this._initPlatformPaths();
        this.form.$setPristine();
    }

    checkAndUpdate() {
        var ctrl = this;
        if (
            !this.isPortalActivate &&
            (this.principal.detail.processP2p ||
                this.principal.detail.processO2c)
        ) {
            this.PrincipalSvc.hasSellerInvited(this.principal.detail.id).then(
                function (data) {
                    if (data) {
                        ctrl.$uibModal
                            .open({
                                component: "modalConfirmPortal",
                                size: "lg",
                            })
                            .result.then(
                            function () {
                                ctrl.update();
                            },
                            function () {}
                        );
                    } else {
                        ctrl.update();
                    }
                },
                function (error) {
                    ctrl.logger.error("error.update", error);
                }
            );
        } else {
            this.update();
        }
    }

    update() {
        var ctrl = this;
        if (this.form.$valid) {
            this.PrincipalSvc.updatePrincipal(this.principal).then(
                (data) => {
                    ctrl.isPortalActivate =
                        ctrl.principal.detail.processP2p ||
                        ctrl.principal.detail.processO2c;
                    if (this.mustCreateAdmin()) {
                        this.PrincipalSvc.createPrincipalAdmin(
                            data.detail.id,
                            this.admin
                        ).then(() => {
                            ctrl.logger.success("success.update", data, null, {
                                entityName: "Le Donneur d'ordre",
                            });
                        });
                    } else {
                        ctrl.logger.success("success.update", data, null, {
                            entityName: "Le Donneur d'ordre",
                        });
                    }
                },
                (error) => {
                    if(ERROR_MESSAGE_MAP.hasOwnProperty(error.data.code)) {
                        ctrl.invalidDomainsList = error.data.effectedDomains.join(', ');
                        ctrl.invalidDomainsErrorMessage = ERROR_MESSAGE_MAP[error.data.code];
                        ctrl.form.ssoDomains.$setValidity('invalidDomains', false);
                        ctrl.form.ssoDomains.$setDirty();
                    }
                }
            );
        }
    }

    /** Indique s'il s'agit du dernier de l'assistant lors de la création d'un DO. */
    isLast() {
        return !this.principal.detail.profilBuyer;
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    isEditNotAuthorized() {
        return !(
            this.AuthSvc.isAuthorized("CONFIGURATOR") ||
            this.AuthSvc.isAuthorized("ADMIN")
        );
    }

    onProcessP2PChange() {
        this.principal.detail.discussInvoiceRe =
            this.principal.detail.processP2p;
        this.principal.detail.managingInvoicee = false;
        this.invoiceRecepted = this.principal.detail.processP2p;
        if (!this.principal.detail.processP2p) {
            this.principal.detail.discussOrderEm = false;
            this.principal.detail.threeWayMatching = false;
        }
        this.principal.detail.orderEm = false;
        this.onOrderEmChange();
    }

    onProcessO2CChange() {
        this.principal.detail.discussInvoiceEm =
            this.principal.detail.processO2c;
        this.principal.detail.facturXDeposit = false;
        this.principal.detail.eInvoiceEntry = false;
        this.principal.detail.managingInvoicer = false;
        this.invoiceSent = this.principal.detail.processO2c;
        if (!this.principal.detail.processO2c) {
            this.principal.detail.discussOrderRe = false;
        }
        this.principal.detail.orderRe = false;
        this.onOrderReChange();
    }

    onOrderEmChange() {
        if (!this.principal.detail.orderEm) {
            this.principal.detail.orderResponseRe =
                this.principal.detail.orderEm;
            this.principal.detail.orderDesAdvRe = this.principal.detail.orderEm;
            this.principal.detail.orderRecAdvEm = this.principal.detail.orderEm;
            this.principal.detail.discussOrderEm =
                this.principal.detail.orderEm;
        }
    }

    onOrderReChange() {
        if (!this.principal.detail.orderRe) {
            this.principal.detail.orderPortalNotifEm =
                this.principal.detail.orderRe;
            this.principal.detail.orderResponseEm =
                this.principal.detail.orderRe;
            this.principal.detail.orderDesAdvEm = this.principal.detail.orderRe;
            this.principal.detail.orderDisplayDesAdvEm =
                this.principal.detail.orderRe;
            this.principal.detail.orderRecAdvRe = this.principal.detail.orderRe;
            this.principal.detail.discussOrderRe =
                this.principal.detail.orderRe;
        }
    }

    isDisabledOrderEm() {
        return (
            !this.principal.detail.orderEm || !this.principal.detail.processP2p
        );
    }

    isDisabledOrderRe() {
        return (
            !this.principal.detail.orderRe || !this.principal.detail.processO2c
        );
    }

    /**Verifie si on doit créer un admin ou non  */
    mustCreateAdmin() {
        var isPortalActivate =
            this.principal.detail.processP2p ||
            this.principal.detail.processO2c;
        return this.create
            ? isPortalActivate
            : isPortalActivate && !this.hasAdmins;
    }
    /**
     * Permet de vérifier si on desactive le boutton next ou non
     */
    isNextButtonDisabled() {
        return (
            (this.principal.detail.processP2p ||
                this.principal.detail.processO2c) &&
            this.mustCreateAdmin() &&
            (this.admin.firstname === null ||
                this.admin.firstname === undefined ||
                this.admin.lastname === null ||
                this.admin.lastname === undefined ||
                this.admin.email === undefined ||
                this.admin.email === null)
        );
    }

    fieldChange(name) {
        if (
            name === "ssoIdentifier" &&
            this.form.ssoIdentifier.$error.unknownPcpAppId
        ) {
            this.form.ssoIdentifier.$setValidity("unknownPcpAppId", true);
        }
    }
}

angular.module("app.principal").component("principalConfigPortal", {
    templateUrl: require("./principal-config-portal.html"),
    controller: PrincipalConfigPortalCtrl,
    bindings: {
        principal: "<",
        create: "<",
    },
});
